import { render, staticRenderFns } from "./managementData.vue?vue&type=template&id=90a66f32&scoped=true&"
import script from "./managementData.vue?vue&type=script&lang=ts&"
export * from "./managementData.vue?vue&type=script&lang=ts&"
import style0 from "./managementData.vue?vue&type=style&index=0&id=90a66f32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a66f32",
  null
  
)

export default component.exports